import { render } from "./NewTeamDialog.vue?vue&type=template&id=3e1a18a0&scoped=true"
import script from "./NewTeamDialog.vue?vue&type=script&lang=js"
export * from "./NewTeamDialog.vue?vue&type=script&lang=js"

import "./NewTeamDialog.vue?vue&type=style&index=0&id=3e1a18a0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e1a18a0"

export default script